import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Scrollbar from 'src/components/scrollbar';
import { HEADER } from '../config-layout';
import { HeaderSimple as Header } from '../_common';

// ----------------------------------------------------------------------

export default function SimpleLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden' }}>
      <Header />
      <Box
        sx={{
          mt: { xs: `${HEADER.H_MOBILE + 1}px`, md: `${HEADER.H_DESKTOP + 1}px` },
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Scrollbar sx={{ height: 1, '& .simplebar-content': { minHeight: '100%' } }}>
          <Box sx={{ minHeight: '100%' }}>{children}</Box>
        </Scrollbar>
      </Box>
    </Box>
  );
}

SimpleLayout.propTypes = {
  children: PropTypes.node,
};
